@if (link) {
  <a class="stat-tile-link d-block h-100 text-reset text-decoration-none" [routerLink]="link">
    <ng-container *ngTemplateOutlet="tileTemplate"></ng-container>
  </a>
}
@else {
  <ng-container *ngTemplateOutlet="tileTemplate"></ng-container>
}

<ng-template #tileTemplate>
  <div class="card stat-tile h-100 mb-0"
       [class.stat-tile-selectable]="selectable"
       [class.stat-tile-selected]="selectable && selected"
       [style.--stat-tile-accent]="accentVar()"
       [attr.role]="selectable ? 'button' : null"
       [attr.tabindex]="selectable ? 0 : null"
       [attr.aria-pressed]="selectable ? selected : null"
       (click)="onTileClick()"
       (keydown.enter)="onTileClick($event)"
       (keydown.space)="onTileClick($event)">
    <div class="card-body">
      <div class="d-flex align-items-start mb-2">
        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
          <p class="stat-tile-label text-uppercase text-muted text-truncate mb-0" [title]="plainLabel()" [innerHTML]="label"></p>
          @if (hint) {
            <i class="stat-tile-hint ri-information-line flex-shrink-0 ms-1"
               [ngbTooltip]="hint"
               [tooltipClass]="hintTooltipClass"
               placement="top"
               container="body"
               (click)="$event.stopPropagation()"></i>
          }
        </div>
        @if (icon) {
          <i class="stat-tile-icon {{ icon }} flex-shrink-0 ms-2"></i>
        }
      </div>

      <h3 class="stat-tile-value mb-0">
        @if (prefix && !loading && value!=null && value!=='') {
          <span class="stat-tile-prefix">{{ prefix }}</span>
        }
        @if (loading) {
          <span class="fs-14 fw-normal text-muted"><i>Loading...</i></span>
        }
        @else if (isNumber() && useCountUp) {
          <span [countUp]="numericValue()" [options]="countUpOptions" [reanimateOnClick]="false"></span>
        }
        @else if (isNumber()) {
          {{ value | number:numberFormat() }}
        }
        @else if (value!=null && value!=='') {
          {{ value }}
        }
        @else {
          <span class="text-muted">-</span>
        }
        @if (suffix && !loading && value!=null && value!=='') {
          <span class="stat-tile-suffix">{{ suffix }}</span>
        }
      </h3>

      @if (hasFooter()) {
        <div class="stat-tile-footer d-flex align-items-center justify-content-between mt-2">
          <span class="text-truncate">
            @if (hasTrend()) {
              <span class="fw-semibold me-1 {{ trendClass() }}"><i class="{{ trendIcon() }} align-middle"></i>{{ trendSize() | number:'1.1-1' }}%</span>
            }
            @if (caption) {
              <span class="text-muted">{{ caption }}</span>
            }
          </span>
          @if (note) {
            <span class="stat-tile-note text-muted ms-2 flex-shrink-0">{{ note }}</span>
          }
        </div>
      }

      <ng-content></ng-content>

      @if (selectable && selected && selectedHint) {
        <div class="stat-tile-selected-hint text-muted text-center mt-2">{{ selectedHint }}</div>
      }
    </div>
    @if (link) {
      <i class="stat-tile-chevron ri-arrow-right-s-line text-muted"></i>
    }
    <ng-content select="[statTileBottom]"></ng-content>
  </div>
</ng-template>
